import React from "react";

import { styled } from "@mui/material";
import {
  Crop as CropIcon,
  InformationOutline as MetasIcon,
} from "mdi-material-ui";

import ImageCropper from "components/common/ImageCropper";
import ImageMetas from "components/common/ImageMetas";
import { useFileUpload } from "components/common/FileUpload";

import ActionsTooltip from "./ActionsTooltip";

const Image = styled("img")`
  max-width: 50px;
  max-height: 50px;
  display: block;
`;

const PreviewImage = React.forwardRef(function _PreviewImage(
  { file, ...props },
  ref
) {
  return <Image ref={ref} src={file.url} alt={file.name} {...props} />;
});

PreviewImage.DefaultActions = function DefaultActions({
  file,
  onChange,
  uploadPath,
  isPublic,
}) {
  const uploadFile = useFileUpload({
    uploadPath,
    isPublic,
  });

  return (
    <>
      <ImageCropper
        file={file}
        onCrop={async (blob) => {
          blob.name = file.name;
          const newFile = await uploadFile(blob);
          onChange({ ...newFile, id: file.id, metas: file.metas });
        }}
      >
        {({ open }) => (
          <ActionsTooltip.Action
            icon={<CropIcon />}
            onClick={open}
            label="Resize & crop"
          />
        )}
      </ImageCropper>

      <ImageMetas
        file={file}
        onChange={(metas) => onChange({ ...file, metas })}
      >
        {({ open }) => (
          <ActionsTooltip.Action
            icon={<MetasIcon />}
            onClick={open}
            label="Métadonnées"
          />
        )}
      </ImageMetas>
    </>
  );
};

export default PreviewImage;
